import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { CustomFieldTypePipe } from '../../../pipes/custom-field-type.pipe';

@Component({
  selector: 'app-custom-field-dropdown',
  standalone: true,
  templateUrl: './custom-field-dropdown.component.html',
  imports: [MatFormField, MatSelect, ReactiveFormsModule, MatOption, MatHint, CustomFieldTypePipe],
  styleUrl: './custom-field-dropdown.component.scss'
})
export class CustomFieldDropdownComponent {
  @Input() group: FormGroup | null = null;
  @Input() allowEmptyValue = false;
  @Input() showHint = false;
}
